import PropTypes from "prop-types";
import { Link } from "react-router-dom";

export default function Navbar({
  title = "TileBars",
  mode,
  handleModeOnChange,
} = {}) {
  // const backgroundColor = mode === "dark" ? "#212529" : null;
  return (
    <nav
      className={`navbar navbar-expand-lg navbar-${mode} bg-${mode}`}
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div
        className="container-fluid"
        style={{
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
        }}
      >
        <Link className="navbar-brand" to="/">
          {title}
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link active" aria-current="page" to="/">
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about">
                About Us
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/image-listing">
                Image Listing
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="form-check form-switch">
        <input
          className="form-check-input"
          type="checkbox"
          role="switch"
          id="flexSwitchCheckDefault"
          onChange={handleModeOnChange}
          style={{ cursor: "pointer" }}
        />
        <label
          className={`form-check-label text-${
            mode === "light" ? "dark" : "light"
          }`}
          htmlFor="flexSwitchCheckDefault"
          style={{ cursor: "pointer", minWidth: "210px" }}
          // onChange={handleModeOnChange}
        >
          {`${mode === "dark" ? "Move back to" : "Enable"} ${
            mode === "light" ? "dark" : "light"
          } mode`}
        </label>
      </div>
    </nav>
  );
}

Navbar.propTypes = {
  title: PropTypes.string.isRequired,
};
